import { inject, Pipe, PipeTransform } from "@angular/core";
import { marked } from "marked";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
	name: "markdown",
	standalone: false
})
export class MarkdownPipe implements PipeTransform {
	private readonly sanitizer = inject(DomSanitizer);

	public transform(text: string): SafeHtml {
		text = marked.parse(text, { async: false });
		text = text.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
		const textSanitized = this.sanitizer.bypassSecurityTrustHtml(text);
		return text && textSanitized ? textSanitized : "";
	}
}
